import React, { useEffect, useState } from 'react';
import { generateReferralQR } from '../utils/qrReferral';
import {
  APP_STORE_URL,
  PLAY_STORE_URL,
  handleAppStoreClick,
  handlePlayStoreClick,
} from '../utils/appStoreLinks';
import './DownloadRedirect.css';

const DownloadRedirect = () => {
  const [qrCode, setQrCode] = useState('');

  useEffect(() => {
    const detectDeviceAndRedirect = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // iOS detection
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // Central referral handoff (clipboard copy) — best effort only;
        // the page unloads immediately after.
        handleAppStoreClick();
        window.location.href = APP_STORE_URL;
        return;
      }
      
      // Android detection
      if (/android/i.test(userAgent)) {
        handlePlayStoreClick();
        window.location.href = PLAY_STORE_URL;
        return;
      }
      
      // Desktop fallback - show app store options
      // Don't redirect, let user choose
    };

    // Small delay to ensure page loads
    const timer = setTimeout(detectDeviceAndRedirect, 100);
    
    return () => clearTimeout(timer);
  }, []);

  // Generate QR code that points to /download page
  // The /download page has device detection to redirect to app store
  useEffect(() => {
    const generateQR = async () => {
      const result = await generateReferralQR('download', {
        width: 200,
        darkColor: '#000000',
        lightColor: '#FFFFFF',
        baseUrl: 'https://thecrappermapper.com'
      });
      if (result) {
        setQrCode(result.qrDataUrl);
      }
    };
    generateQR();
  }, []);

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  const isAndroid = /android/i.test(userAgent);
  const isDesktop = !isIOS && !isAndroid;

  return (
    <div className="download-redirect">
      <div className="redirect-container">
        <img 
          src="/app-icon.png" 
          alt="The Crapper Mapper" 
          className="app-icon-large"
        />
        
        <h1 className="app-title">The Crapper Mapper</h1>
        <p className="app-tagline">Get the #1 App for your #2 Needs</p>
        
        {isDesktop && (
          <div className="desktop-options">
            <h2>Choose Your Device</h2>
            <p>Scan the QR code with your phone or choose your app store:</p>
            
            <div className="store-buttons">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="store-button ios"
                onClick={() => handleAppStoreClick()}
              >
                <img 
                  src="/assets/badges/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" 
                  alt="Download on the App Store" 
                  className="store-badge"
                />
              </a>
              
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="store-button android"
                onClick={() => handlePlayStoreClick()}
              >
                <img
                  src="/assets/badges/GetItOnGooglePlay_Badge_Web_color_English.png"
                  alt="Get it on Google Play"
                  className="store-badge"
                />
              </a>
            </div>
            
            <div className="qr-section">
              <p>Or scan this QR code:</p>
              <div className="qr-code-container">
                {qrCode ? (
                  <img src={qrCode} alt="Download QR Code" className="qr-image" />
                ) : (
                  <div className="qr-loading">Generating QR Code...</div>
                )}
              </div>
            </div>
          </div>
        )}
        
        {isIOS && (
          <div className="redirecting">
            <div className="spinner"></div>
            <p>Redirecting to App Store...</p>
            <p>If not redirected, click below:</p>
            <a
              href={APP_STORE_URL}
              className="manual-link"
              onClick={() => handleAppStoreClick()}
            >
              Download from App Store
            </a>
          </div>
        )}
        
        {isAndroid && (
          <div className="redirecting">
            <div className="spinner"></div>
            <p>Redirecting to Google Play...</p>
            <p>If not redirected, click below:</p>
            <a
              href={PLAY_STORE_URL}
              className="manual-link"
              onClick={() => handlePlayStoreClick()}
            >
              Download from Google Play
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default DownloadRedirect;
